import React from 'react';
import './DeleteTechnicianModal.css';
import deleteIcon from '../assets/images/Delete.svg';

const DeleteTechnicianModal = ({ open, onClose, onDelete }) => {
  if (!open) return null;
  return (
    <div className="delete-tech-modal-overlay">
      <div className="delete-tech-modal slide-in">
        <button className="delete-tech-modal-close" onClick={onClose}>&times;</button>
        <div className="delete-tech-modal-header">
          <span className="delete-tech-modal-icon">
            <span className="delete-tech-modal-icon-bg">
              <img src={deleteIcon} alt="delete" style={{width:16, height:16}} />
            </span>
          </span>
          <span className="delete-tech-modal-title">Delete Technician</span>
        </div>
        <hr className="delete-tech-modal-divider" />
        <div className="delete-tech-modal-message">
          Are you sure you want to delete this Technician? This action cannot be undone.
        </div>
        <div className="delete-tech-modal-actions">
          <button className="delete-tech-modal-cancel" onClick={onClose}>Cancel</button>
          <button className="delete-tech-modal-delete" onClick={onDelete}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTechnicianModal;
